import { rawGET } from "services/httpService";
import { getAppConfig } from "services/configService";
import urlJoin from "url-join";

const apiUrl = () => {
  return getAppConfig().DeliveryApiUrl;
};

export const getOrderDelivery = async (requestInfo, orderCode) => {
  const res = await rawGET(requestInfo, urlJoin(apiUrl(), `/OrderDeliveryDates/${orderCode}`));

  if (res.status === 404) {
    return null;
  }

  if (!res.ok) {
    throw new Error(await res.text());
  }

  return res.json();
};
